<template>
  <div>
    <FormLanguageBar v-model="activeLanguage">
      <div class="field is-grouped" slot="right-buttons">
        <p class="control">
          <router-link to="/dashboard/capsules" tag="a" class="button"
            >Cancel</router-link
          >
        </p>
        <p class="control">
          <a
            class="button"
            :class="{ 'is-info': isEdition, 'is-success': !isEdition }"
            @click="sendForm"
            >Save</a
          >
        </p>
      </div>
    </FormLanguageBar>
    <section class="section">
      <div class="container">
        <div
          class="has-text-left box"
          v-for="group in form.groups"
          :key="group.id"
        >
          <h6 class=" title is-6 is-uppercase">
            {{ $t(`Admin.Groups.${group.name}`) }}
          </h6>
          <div>
            <div v-for="field in group.fields" :key="field.id">
              <p>{{ field | visibleName }}</p>
              <!-- eslint-disable  vue/valid-v-model -->
              <component
                :is="componentToLoad(field.type)"
                class="is-fullwidth"
                v-if="inputValues[field.name]"
                :fieldProperties="field.properties"
                v-model="inputValues[field.name][activeLanguageForField(field)]"
              />
            </div>
          </div>
        </div>
        <div class="box">
          <h6 class="has-text-left title is-6 is-uppercase">
            {{ $t(`Admin.Groups.collections`) }}
          </h6>
          <admin-collection-dropdown v-model="inputValues.collections"/>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FormLanguageBar from '@/components/FormLanguageBar'
import FormTextarea from '@/components/FormTextarea'
import FormText from '@/components/FormText'
import FormFile from '@/components/FormFile'
import FormIcon from '@/components/FormIcon'
import FormSelect from '@/components/FormSelect'
import FormTag from '@/components/FormTag'
import AdminCollectionDropdown from '@/components/AdminCollectionDropdown'
import { fetchItem, updateItem } from '@/services/API'
import { _ } from 'underscore'
export default {
  name: 'form-creation',
  components: {
    FormLanguageBar,
    FormText,
    FormTextarea,
    FormFile,
    FormIcon,
    FormSelect,
    FormTag,
    AdminCollectionDropdown
  },
  mounted () {
    let self = this
    this.$store.dispatch('getForm').then(function (result) {
      const names = _.pluck(result.data.fields, 'name')
      _.each(names, function (name, index) {
        if (result.data.fields[index].properties.multilingual) {
          self.$set(self.inputValues, name, {
            es: '',
            ca: '',
            en: '',
            default: ''
          })
        } else {
          self.$set(self.inputValues, name, {
            default: ''
          })
        }
      })
      if (self.$route.params.id) {
        fetchItem('projects', self.$route.params.id).then(result => {
          const keys = _.keys(result.data[0])
          _.each(keys, (key, index) => {
            self.inputValues[key] = {
              ...self.defaultInputValues[key],
              ...result.data[0][key]
            }
          })
          self.inputValues.collections = _.toArray(self.inputValues.collections)
        })
        /* self.$store
          .dispatch('getCapsule', {
            params: { id: self.$route.params.id }
          })
          .then(result => {
            const keys = _.pluck(result.data.fields, 'name')
            console.log(keys)
            _.each(keys, (key, index) => {
              self.inputValues[key] = {
                ...self.defaultInputValues[key],
                ...result.data.fields[index].values
              }
            })
          }) */
      }
    })
  },
  data () {
    return {
      // inputValues: {}
    }
  },
  computed: {
    ...mapState({
      form: function (state) {
        const groupedFields = _.groupBy(state.Api.form.fields, 'group')
        _.map(state.Api.form.groups, function (group) {
          group.fields = groupedFields[group.id]
          return group
        })
        return state.Api.form
      }
    }),
    inputValues: {
      get () {
        return this.$store.state.form
      },
      set (value) {
        // this.$store.commit('changeActiveLanguage', value)
      }
    },
    activeLanguage: {
      get () {
        return this.$store.getters.activeLanguage
      },
      set (value) {
        this.$store.commit('changeActiveLanguage', value)
      }
    },
    isEdition: function () {
      return (
        this.$route.query.edit === true || this.$route.query.edit === 'true'
      )
    },
    formNames: function () {
      return _.pluck(this.form.fields, 'name')
    },
    defaultInputValues: function () {
      return _.object(
        this.formNames,
        _.map(this.formNames, (name, index) => {
          if (this.form.fields[index].properties.multilingual) {
            return {
              es: undefined,
              ca: undefined,
              en: undefined,
              default: undefined
            }
          } else {
            return {
              default: undefined
            }
          }
        })
      )
    }
  },
  methods: {
    activeLanguageForField: function (field) {
      if (field.properties.multilingual) {
        return this.activeLanguage
      } else return 'default'
    },
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    componentToLoad: function (fieldType) {
      return 'Form' + this.capitalize(fieldType)
    },
    sendForm: function () {
      this.inputValues.projectType = this.form.name
      if (this.isEdition) {
        updateItem('projects', this.$route.params.id, this.inputValues).then(result => {
          this.$store.dispatch('getCapsules')
          this.$snotify.success(this.$t('saved_successfully'), {
            timeout: 2000,
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true
          })
        })
          .catch(err => console.log(err))

        /* this.$store
          .dispatch('updateCapsule', {
            data: _.extend(data, { id: this.$route.params.id })
          }) */
      } else {
        var multilingualFields = _.chain(this.form.fields)
          .filter(function (field) {
            return field.properties.multilingual === 'true'
          })
          .pluck('name')
          .value()
        let data = this.$store.state.form

        data = _.mapObject(data, function (value, key) {
          if (_.contains(multilingualFields, key)) {
            return value
          } else {
            return { default: value.default }
          }
        })
        data.projectType = this.form.name
        this.$store
          .dispatch('createCapsule', { data })
          .then(result => {
            this.$store.dispatch('getCapsules')
            // this.$router.push('/dashboard/capsules')
            this.$snotify.success(this.$t('saved_successfully'), {
              timeout: 2000,
              showProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true
            })
          })
          .catch(err => console.log(err))
      }
    }
  },
  filters: {
    visibleName: function (field) {
      if (field.properties.visibleName) {
        return (
          field.properties.visibleName[navigator.language.split('-')[0]] ||
          field.name
        )
      }
      return field.name
    }
  }
}
</script>
<style>
</style>
